export interface PreviewSession {
  sourceAppId: string;
  previewAppId: string;
  previewAppName: string;
  createdAt: string;
}

export interface PreviewReviewState {
  sourceAppId: string;
  previewAppId: string;
  reviewToken: string;
  reviewedObjectIds: string[];
  completedAt?: string;
  syncStatus?: 'in_sync' | 'qlik_ahead' | 'git_ahead' | 'auto_merge' | 'conflict';
  gitHeadCommit?: string;
  gitChangeCount?: number;
  qlikChangeCount?: number;
  conflictCount?: number;
}

const key = (appId: string) => `click-ci:preview:${appId}`;
const reviewKey = (appId: string) => `click-ci:preview-review:${appId}`;

export const readPreviewSession = (appId: string): PreviewSession | undefined => {
  try {
    const value = window.sessionStorage.getItem(key(appId));
    return value ? JSON.parse(value) as PreviewSession : undefined;
  } catch {
    return undefined;
  }
};

export const savePreviewSession = (session: PreviewSession) => {
  try {
    window.sessionStorage.setItem(key(session.sourceAppId), JSON.stringify(session));
  } catch {
    // The current page can still use its in-memory state when storage is unavailable.
  }
};

export const clearPreviewSession = (appId: string) => {
  try {
    window.sessionStorage.removeItem(key(appId));
    window.sessionStorage.removeItem(reviewKey(appId));
  } catch {
    // Nothing else is required when storage is unavailable.
  }
};

export const clearPreviewReview = (appId: string) => {
  try {
    window.sessionStorage.removeItem(reviewKey(appId));
  } catch {
    // Nothing else is required when storage is unavailable.
  }
};

export const readPreviewReview = (appId: string): PreviewReviewState | undefined => {
  try {
    const value = window.sessionStorage.getItem(reviewKey(appId));
    return value ? JSON.parse(value) as PreviewReviewState : undefined;
  } catch {
    return undefined;
  }
};

export const savePreviewReview = (state: PreviewReviewState) => {
  try {
    window.sessionStorage.setItem(reviewKey(state.sourceAppId), JSON.stringify(state));
  } catch {
    // Review can still continue in memory when storage is unavailable.
  }
};
